import { getDevConfig } from '@/devwars'

export function defineSession(store) {
  store.commit('firstSet', { orderType: 'openSession' })

  // подставляем моковые данные на локалке (DevWars-конфиг, см. .agents/skills/devwars)
  if (import.meta.env.DEV) {
    const cfg = getDevConfig()
    window.authed = cfg.authed
    window.person = cfg.person
    store.commit('firstSet', { IS_COUNTRY_GLOBAL: cfg.IS_COUNTRY_GLOBAL })
    store.commit('firstSet', { CUR_LOCATION: cfg.CUR_LOCATION })
    store.commit('firstSet', { country: cfg.country })
    store.commit('firstSet', { currency: cfg.currency })
  }

  // Пользователь залогинен
  if (window.person) {
    store.commit('firstSet', { userInfo: window.person })
  }

  // Если авторизован — определяем, какую сессию дать
  // if (window.authed) {
  //   const profiles = store.state.deliveryProfiles || []
  //   const hasLastChoices = profiles.some((p) => p.LAST_CHOICES)

  //   if (hasLastChoices || profiles.length > 0) {
  //     store.commit('firstSet', { orderType: 'closedSession' })
  //   } else {
  //     store.commit('firstSet', { deliveryProfiles: [] })
  //   }
  // } else {
  store.commit('firstSet', { orderType: 'unAuthSession' })
  // }
}
